import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService, SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';
import { PayoutRateHttpModel } from './payout-rates.model';

@Injectable({
  providedIn: 'root',
})
export class PayoutRatesHttpService extends SupabaseBaseHttpService<'payout_rates', 'billing'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'billing';
  readonly tableName = 'payout_rates';
  override readonly id_field = 'user_id' as const;

  override fetchMaybeSingle(userId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq(this.id_field, userId)
        .is('valid_to', null)
        .maybeSingle()
        .throwOnError()
        .then((response) => response.data),
    );
  }

  override fetchAll() {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .is('valid_to', null)
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  fetchUserRateHistory(userId: string): Observable<PayoutRateHttpModel[]> {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq('user_id', userId)
        .order('valid_from', { ascending: false })
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
